<template>
    <v-text-field 
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                   :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  />
</template>

<script>
    export default {

        name: 'common-password',
        props: {
        },
        components: {

        },
        methods: {

        },
        data() {
            return {
                showPassword: false,
            };
        },
        watch: {

        },
        mounted() {
            
        },
        setup() {
            return {};
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
